import React, { Fragment } from 'react';

import type { WModuleGroupView } from '@zola/svc-web-api-ts-client';

import { StyledCarousel } from './PromoTileCarousel.styles';
import { PromoTile } from './PromoTile';

export type PromoTileCarouselProps = {
  promoModuleGroup: WModuleGroupView;
};
const carouselSettings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  autoplay: true,
  autoplaySpeed: 5000,
  pauseOnFocus: true,
  pauseOnHover: true,
};

export const PromoTileCarousel = (props: PromoTileCarouselProps) => {
  const { promoModuleGroup } = props;

  const { moduleViews } = promoModuleGroup;

  if (!moduleViews) {
    return <Fragment />;
  }

  const content = moduleViews.map((module, idx) => {
    return <PromoTile module={module} position={idx} key={`promo-tile-${idx}`} />;
  });

  return <StyledCarousel settings={carouselSettings} content={content} />;
};

export default PromoTileCarousel;
